import type {
  Invitation,
  InvitationStatus,
  OnboardingDraft,
  OnboardingError,
  SubmitStatus,
} from '../domain/onboarding.model';

/**
 * Redux state for the Onboarding flow: the on-mount invitation check (who was
 * invited, or why the link is dead), the editable draft, per-field validation
 * errors, the submit lifecycle, and the last business error. The one-time
 * token is NOT here; the URL stays its single source of truth (the page reads
 * it and passes it in the signal actions' payloads), so no stale token ever
 * lingers in the store. `showPassword` is a pure display toggle and lives as
 * local state in the view. Every field is serialisable.
 */
export interface OnboardingState {
  invitation: Invitation | null;
  invitationStatus: InvitationStatus;
  /** User-facing message when the invitation link is invalid/expired. */
  invitationError: string | null;
  draft: OnboardingDraft;
  validationErrors: Record<string, string>;
  status: SubmitStatus;
  error: OnboardingError | null;
}

export const emptyDraft: OnboardingDraft = { password: '', confirmPassword: '' };

export const initialState: OnboardingState = {
  invitation: null,
  invitationStatus: 'idle',
  invitationError: null,
  draft: emptyDraft,
  validationErrors: {},
  status: 'idle',
  error: null,
};
